import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Mail, Lock, ArrowLeft } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { formatAxiosError } from '../lib/api';
import GoogleSignInButton from '../components/GoogleSignInButton';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      const user = await login(form.email, form.password);
      const next = location.state?.from || '/dashboard';
      navigate(next, { replace: true });
      // user role-based routing handled by Dashboard which shows Admin Panel link for admins
      void user;
    } catch (err) {
      setError(formatAxiosError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page" data-testid="login-page">
      <div className="auth-card">
        <Link to="/" className="auth-back" data-testid="back-to-home">
          <ArrowLeft size={16} /> Back to home
        </Link>
        <h1 className="auth-title">Welcome back</h1>
        <p className="auth-subtitle">Continue your journey of healing & transformation.</p>

        <GoogleSignInButton label="Continue with Google" />
        <div className="auth-divider"><span>or</span></div>

        <form onSubmit={onSubmit} className="auth-form">
          <div className="auth-field">
            <label>Email</label>
            <div className="auth-input-wrap">
              <Mail size={16} />
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={onChange}
                required
                placeholder="you@example.com"
                data-testid="login-email"
              />
            </div>
          </div>
          <div className="auth-field">
            <label>Password</label>
            <div className="auth-input-wrap">
              <Lock size={16} />
              <input
                type="password"
                name="password"
                value={form.password}
                onChange={onChange}
                required
                minLength={6}
                placeholder="Your password"
                data-testid="login-password"
              />
            </div>
          </div>

          {error && <div className="auth-error" data-testid="login-error">{error}</div>}

          <button
            type="submit"
            disabled={submitting}
            className="btn-primary btn-large btn-full"
            data-testid="login-submit"
          >
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <p className="auth-foot">
          New here?{' '}
          <Link to="/signup" state={location.state} data-testid="link-to-signup">
            Create an account
          </Link>
        </p>
      </div>
    </div>
  );
}
